import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import Button from '../../Button';
import Paragraph from '../../Paragraph';
import { Row } from '../../Register/Scaffold';

class LivewellReview extends React.PureComponent {
  componentDidMount() {

  }

  render() {
    const { prevPage, handleSubmit } = this.props;

    return (
      <Row classes="lw-review">
        <form onSubmit={handleSubmit} className="form-register">
          <Paragraph classes="section-text alcohol-unit-section" center><strong>How likely are you to recommend LiveWell Dorset to family and friends?</strong></Paragraph>

          <Paragraph classes="section-text width-limited" center><strong>Anything else you'd like to share? Please send any feedback to <a href="mailto:queries@livewelldorset.co.uk">queries@livewelldorset.co.uk</a></strong>
          </Paragraph>

          <Paragraph classes="button-groups divideline" center>
            <Button classes={['color-button']} label="Next" onClick={handleSubmit} />
            <Button classes={['underline-button']} label="Back" onClick={prevPage} />
          </Paragraph>
        </form>
      </Row>
    );
  }
}

LivewellReview.propTypes = {
  prevPage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'assessment', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(LivewellReview);



// WEBPACK FOOTER //
// ./src/Components/Assessment/Pages/LivewellReview.jsx